<template>
	<div class="app-menu">
		<appLogo></appLogo>
		<!-- jxd后台  -->
		<div v-if="currentAccountSets" class="h-menu h-menu-dark" :class="sliderCollapsed?'h-menu-mode-collapse':'h-menu-mode-vertical'">
			<li class="h-menu-li h-menu-first-level" v-for="m in menus" @click="trigger(m)">
				<Tooltip v-if="sliderCollapsed&& m.children &&!m.children.length" :content="m.title" placement="right">
					<div class="h-menu-show" :class="{' h-menu-li-selected':selected(m)}">
						<span class="h-menu-show-icon" v-if="m.icon">
							<i :class="m.icon"></i>
						</span>
						<span class="h-menu-show-desc text-16px">{{ m.title }}</span>
						<span class="h-menu-show-expand" v-if="m.children"><i class="h-icon-angle-down"></i></span>
					</div>
				</Tooltip>
				<template v-else>
					<div class="h-menu-show" :class="{' h-menu-li-selected':selected(m)}" style="line-height: calc(1.8vh)">
						<span class="h-menu-show-icon" v-if="m.icon">
							<img class="h-menu-show-image" v-if="selected(m)" :src="bindIcon(m.icons)" />
							<img class="h-menu-show-image" v-else :src="bindIcon(m.icon)" />
						</span>
						<span class="h-menu-show-desc text-16px">{{ m.title }}</span>
						<span class="h-menu-show-expand" v-if="m.children"><i class="h-icon-angle-down"></i></span>
					</div>
				</template>
				<div class=" h-menu-other-levels !flex" :class="{'flex-column':m.children.filter(val=>val.children).length===0}" v-if="m.children && m.children.length">
					<template v-for="c1 in m.children">
						<template v-if="c1.children && c1.children.length">
							<div class="flex-1 m-8px">
								<div class="py-8px px-4px primary-color font-bold text-14px"> {{ c1.title }}</div>
								<div @click.stop="trigger(c2)" class="p-6px text-hover text-14px jxd-bk" :class="currentTab === c2.key?'font-bold primary-color':''" v-for="c2 in c1.children" :key="c2.key">
									{{ c2.title }}
								</div>
							</div>
						</template>
						<div v-else :class="currentTab === c1.key?'font-bold primary-color':''" class="py-8px px-16px text-hover text-14px jxd-bk" @click.stop="trigger(c1)">
							{{ c1.title }}
						</div>
					</template>
				</div>
			</li>
		</div>
		<div class="version">
			<div>V{{ VERSION }}.0</div>
			<!-- <div>{{ dFormat(BUID_DATE, 'YYYYMMDDHHmmss') }}</div> -->
		</div>
	</div>
</template>
<script>
	import {mapMutations, mapState} from 'vuex';
	import appLogo from './app-logo';
	import $ from 'jquery';
	import report from "../../api/report";

	export default {
		name: "AppMenu",
		props: {
			theme: String
		},
		computed: {
			...mapState(['User', 'sliderCollapsed', 'currentAccountSets', 'currentTab', 'menus'])
		},
		methods: {
			...mapMutations(['newTab']),
			selected(item) {
				if (this.menus) {
					let find = this.menus.find(val => {
						if (val.key === this.currentTab) {
							return true;
						} else if (val.children) {
							for (const c1 of val.children) {
								if (c1.key === this.currentTab) {
									return true;
								} else if (c1.children) {
									for (const c2 of c1.children) {
										if (c2.key === this.currentTab) {
											return true;
										}
									}
								}
							}
						}
					})
					return find && (item.key === find.key);
				}
				return false;
			},
			trigger(data) {
				if (!data.children) {
					if (data.key === 'Home' && this.currentTab !== data.key) {
						this.$store.commit('refreshHomeTab', {key: "Home", title: "首页"})
					} else this.newTab(data);
				}
			},
			hideMenu() {
				this.$store.commit('updateSliderCollapse', true);
			},
			bindIcon(icon) {
				return require("@/assets/menu/" + icon + ".png");
			}
		},
		components: {
			appLogo
		},
		created() {
			if (this.menus) {
				// jxd可以在这控制左侧菜单,实现版本控制
				console.log(this.menus)
				//如果是工会准则 村集体 个体 非盈利，去掉分析按钮
				if(this.User.accountSets.accountStandard == "GENERAL_SCHOOL" || this.User.accountSets.accountStandard == "NONGOVERNMENTAL2026" || this.User.accountSets.accountStandard == "GENERAL_CANTEEN" || this.User.accountSets.accountStandard == "NONGOVERNMENTAL" || this.User.accountSets.accountStandard == "BUSINESS_NEW_2019" || this.User.accountSets.accountStandard == "TRADE_UNION" || this.User.accountSets.accountStandard == "VILLAGE_COLLECTIVE" || this.User.accountSets.accountStandard == "SELF_EMPLOYED" || this.User.accountSets.accountStandard == "ADMINISTRATIVE_PUBLIC_INSTITUTIONS" || this.User.accountSets.accountStandard == "PARTY_FEE" || this.User.accountSets.accountStandard == "RURAL_COLLECTIVE_ECONOMIC_ORGANIZATIONS"){
					for(let i = 0;i<this.menus.length;i++){
						if(this.menus[i].title == "分析"){
							this.menus.splice(i, 1); // 移除该项
						}		
					}
				}
				//如果是党费准则，去掉固定资产模块
				if(this.User.accountSets.accountStandard == "PARTY_FEE"){
					for(let i = 0;i<this.menus.length;i++){
						if(this.menus[i].title == "固定资产"){
							this.menus.splice(i, 1); // 移除该项
						}		
					}	
				}
				// if(this.menus[0].key == 'Home'){
				// 	this.menus.splice(0, 1);
				// }
				report.template.select().then(({data}) => {
					// 重分类
					if(data.find(item => item.templateKey === 'zcfzbcfl')){
						this.$store.commit('setIsCfl', true);
						for(let i = 0;i<data.length;i++){
							if(data[i].templateKey === 'zcfzbcfl'){
								data.splice(i, 1)
							}
						}			
					}
					const reportList = this.menus.find(val => val.key === "ReportList")
					if (reportList) {
						data.forEach(item => {
							item.dimensions.forEach(d => {
								if (reportList.children) {
									reportList.children.push({
										title: item.name + (d === 'QUARTER' ? "季报" : ''),
										key: "ReportView:" + item.templateKey + (d === 'QUARTER' ? ":" + d : ''),
										params: {
											reportId: item.templateKey,
											dimension: d
										}
									})
								}
							})
						})
					}
					//这里对税务模块进行整理，首先，版本是低于巅峰的，去掉报表中的ns1-ns6
					//然后，版本是巅峰的且准则是企业小企业2019的，将报表中的ns1-ns6,放到税务模块下
					if(this.User.role == 'ManagerApexe' || this.User.role == 'MakingApexe' || this.User.role == 'ViewApexe'){
						console.log(1)
						if(this.User.accountSets.accountStandard == "SMALL_BUSINESS" || this.User.accountSets.accountStandard == "BUSINESS" || this.User.accountSets.accountStandard == "BUSINESS_NEW_2019"){
							console.log(12)
							let array = [];
							for(let i = 0;i<this.menus.length;i++){
								if(this.menus[i].title == "报表"){
									array.push(this.menus[i].children[5]);
									array.push(this.menus[i].children[6]);
									array.push(this.menus[i].children[7]);
									array.push(this.menus[i].children[8]);
									array.push(this.menus[i].children[9]);
									array.push(this.menus[i].children[10]);
								}		
							}
							for(let i = 0;i<this.menus.length;i++){
								if(this.menus[i].title == "税务"){
									console.log(12555,array,this.menus[i])
									this.menus[i].children = array;
								}		
							}
							for(let i = 0;i<this.menus.length;i++){
								if(this.menus[i].title == "报表"){
									this.menus[i].children.splice(5, 6);
								}		
							}
						}else{
							console.log(111)
							for(let i = 0;i<this.menus.length;i++){
								if(this.menus[i].title == "税务"){
									this.menus.splice(i, 1); // 移除该项
								}		
							}
						}
					}else{
						for (let i = 0; i < this.menus.length; i++) {
							if (this.menus[i].title === "报表") {
								const validKeys = ["ReportView:ns1", "ReportView:ns2", "ReportView:ns3", "ReportView:ns4", "ReportView:ns5", "ReportView:ns6"];
								this.menus[i].children = this.menus[i].children.filter(item => 
								  !validKeys.includes(item.key)
								);
							}
						}
					}
				});
			}
		},
		mounted() {
			$('.h-menu .h-menu-first-level').hover((e) => {
				const maxHeight = window.document.body.scrollHeight;
				const other = $('.h-menu-other-levels', e.currentTarget);
				if (other.length) {
					const offset = $(e.currentTarget).offset()
					const height = other.height()
					if (offset.top + height > maxHeight) {
						other.offset({
							top: maxHeight - height - 30
						})
					} else {
						other.offset({
							top: offset.top
						})
					}
				}
			})
		}
	};
</script>
<style lang="less" scoped>
	.version {
		position: absolute;
		font-weight: bold;
		bottom: 0;
		left: 0;
		width: 100%;
		color: white;
		text-align: center;
		z-index: -1;
		font-size: 12px;
		white-space: nowrap;
	}

	.h-menu-mode-vertical {
		> .h-menu-li {
			> .h-menu-show {
				// padding-left: 10px;
				// padding: 18px 0 18px 10px;
				padding: calc(1.8vh) 0 calc(1.8vh) 10px;
				// background-color: #6754ff;//每个按钮左侧导航栏默认的背景色
				//background: linear-gradient(135deg, #6754ff, #8568ff);
			}
		}

		//导航栏按钮选中颜色
		.h-menu-li-selected{
			color: @white-color !important;
			background-color: #2c4258;
		}

		.h-menu-show {
			overflow: hidden;
			text-overflow: ellipsis;
			color: #d1d6da;//文字颜色
			padding: 15px 10px;
			transition: color @transition-time;

			&-icon {
				margin-right: 5px;
			}
			.h-menu-show-image {
				float: left;
				height: 18px;
			}

			&-expand {
				> i {
					transition: transform @transition-time;
					transform: rotate(-90deg);
				}
				right: 10px;
			}
		}

		.h-menu-other-levels {
			background-color: #FFFFFF !important;
			box-shadow: @box-shadow;
			color: #001529 !important;
			padding: 5px 0;
			margin-left: 4px;
			left: 100%;
			top: 0;
			border-radius: 10px;
			overflow: hidden;
			position: absolute;
			width: 0;
			transition: 0.2s cubic-bezier(0.78, 0.17, 0.43, 1);
			white-space: nowrap;
			display: inline-block;
			opacity: 0.8;
			transform: scale(0.8);
			transform-origin: left;
			max-height: initial !important;

			.h-menu-show {
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.h-menu-li:hover {
			> .h-menu-other-levels {
				width: auto;
				opacity: 1;
				transform: scale(1);
				overflow: visible;
				border: 1px solid #eeeeee;//悬浮弹出的边框颜色

				&:before {
					content: '';
					position: absolute;
					height: 100%;
					top: 0;
					left: -10px;
					width: 10px;
				}
			}
		}
	}

	.h-menu.h-menu-mode-collapse .h-menu-other-levels {
		width: 0 !important;
		max-width: none !important;
	}

	.h-menu.h-menu-mode-collapse {
		.h-menu-li:hover {
			.h-menu-other-levels {
				width: auto !important;
				color: @white-color;
			}
		}
	}

	//每个按钮悬浮背景色
	.h-menu-dark .h-menu-show:hover {
		// background-color: #8568ff;
		background-color: #2c4258;
	}
	//导航栏每个按钮间隔背景色
	.h-menu-dark {
		// background-color: #6754ff;
		//background: linear-gradient(135deg, #6754ff, #8568ff);
		background-color: transparent;
	}
	.jxd-bk{
		padding: 12px 20px;
	}
</style>
